import apiRequest from "@core/services/api/apiRequest";
import type { JoinVideoRoomRequest, JoinVideoRoomResponse } from "@platform/features/video/types/video.types";
import { getTrackingMetadata } from "../getTrackingMetadata";

export { JoinVideoRoomRequest, JoinVideoRoomResponse };

export const joinVideoRoom = async (request: JoinVideoRoomRequest, user: { id: number } | null): Promise<JoinVideoRoomResponse> => {
  // Get tracking metadata
  const trackingMetadata = getTrackingMetadata(user);
  
  // Include tracking metadata in the request
  const requestWithMetadata = {
    ...request,
    ...trackingMetadata,
  };
  
  return apiRequest("/api/video-rooms/join/", "POST", requestWithMetadata);
}; 